import { KeycloakService } from "keycloak-angular";
import { keycloakEnvironment, environment } from "../../environments/environment";
import { createScript } from "@shared/heplers/helpers";
import { customEcommerce } from "src/assets/custom-ecommerce/custom";

export function initializer(keycloak: KeycloakService): () => Promise<any> {
  let initOptions: any = {
    onLoad: "check-sso",
    checkLoginIframe: false,
  };

  if (environment.isSilentLogin) {
    const hostname = window.location.hostname;
    const subdomain = hostname.split('.')[0];
    if(hostname != environment.domain){
      const redirectUri = `https://${subdomain}.ciaotickets.com/ecommerce/`
      initOptions.silentCheckSsoRedirectUri = redirectUri + environment.silentCheckSsoRedirectUri;
    }else{
      initOptions.silentCheckSsoRedirectUri = keycloakEnvironment.redirectUri + environment.silentCheckSsoRedirectUri;
    }
  }

  return (): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      if (environment.isQueueing) {
        await loadScript();
      }
      const { keycloakConfig } = keycloakEnvironment;
      const currentUrl = window.location.href;
      const targetRoutePattern = /\/promoter\/inviti-ricevuti\/[^/]+\/accetta/;

    if (targetRoutePattern.test(currentUrl)) {
      keycloakConfig.clientId =  environment.clientIdForPR;
    }

    const hostname = window.location.hostname;
    const subdomain = hostname.split('.')[0];
    if(hostname != environment.domain){
      environment.baseUrl = `https://${subdomain}.ciaotickets.com/api/`
      environment.host = `https://${subdomain}.ciaotickets.com/`
      keycloakEnvironment.redirectUri = `https://${subdomain}.ciaotickets.com/ecommerce/`
      keycloakConfig.clientId =  customEcommerce[subdomain].clientId;
    }

      
      try {
        await keycloak
          .init({
            config: keycloakConfig,
            initOptions: initOptions,
            enableBearerInterceptor: true,
            bearerExcludedUrls: [
                                  '/api/planning/public',
                                  '/api/selling/public',
                                  '/api/registries/public'
                                ]
          })
          .then((auth) => {
            if (auth) {
              keycloak.getToken().then((token) => {
                localStorage.setItem("authToken", token);
              });
            } else {
              localStorage.removeItem("authToken");
            }
          });
        resolve(true);
      } catch (error) {
        reject(error);
      }
    });
  };
}

async function loadScript() {
  const dataScript = {
    "data-queueit-spa": "true",
    "data-queueit-c": "ciaotickets",
  };

  await createScript("//static.queue-it.net/script/queueclient.min.js", "text/javascript");
  await createScript("//static.queue-it.net/script/queueconfigloader.min.js", "text/javascript", dataScript);
}
